<div class="text-align-center">
    <button (click)="click($event)" class="button half-height">{{buttonText}}</button>
</div>